var map = {
	"./address.svg": "25c4",
	"./finished.svg": "71dd",
	"./fire.svg": "af81",
	"./other.svg": "7b2c",
	"./overdue.svg": "1521",
	"./process1.svg": "2f43",
	"./process2.svg": "aa06",
	"./process3.svg": "c28f",
	"./refund_order.svg": "6a8e",
	"./refunding.svg": "c55b",
	"./returned.svg": "259f",
	"./service-tel.svg": "c9d5",
	"./store.svg": "387f0",
	"./tel.svg": "8875",
	"./used.svg": "473d",
	"./valid.svg": "9ebc",
	"./wenhao.svg": "7310"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";